import { useMemo } from "react";
import { useLocation } from "react-router-dom";
import { parsePreselectedTeeth } from "../paths";

/** Teeth chosen before the product was created, carried by the `?teeth=` param. */
export const usePreselectedTeeth = (): number[] => {
  const { search } = useLocation();

  return useMemo(() => parsePreselectedTeeth(search), [search]);
};
